import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100",
  style: {}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  id: "wDay",
  style: {"height":"36px"},
  class: "fw600 fl mt14 mr10 fs18"
}
const _hoisted_5 = {
  key: 0,
  class: "fl"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "fw600 fl ml5 mr5 mt17",
  style: {}
}, "〜", -1)
const _hoisted_7 = {
  key: 0,
  class: "fl redColor fw600 mt20 fs12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.ev)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", null, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/logo/menu_icon03.png`),
              class: "fl",
              style: {"margin-top":"15px","width":"18px","height":"18px"}
            }, null, 8, _hoisted_2)
          ]),
          _createElementVNode("input", {
            value: _ctx.date,
            class: "fw600 fl noBorder mr10 ml10 arial fs24",
            type: "date",
            style: {"width":"240px","height":"50px"},
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputDate && _ctx.inputDate(...args)))
          }, null, 40, _hoisted_3),
          _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.getWdayText) + ")", 1),
          (!_ctx.ev.allday)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_SelectTag, {
                  name: "meeting_start_time",
                  id: "select_meeting_start_time",
                  class: "fl fs20 roundForm noBorder arial",
                  style: {"width":"90px","min-width":"00px","height":"50px"},
                  options: _ctx.timeArray,
                  defaultOption: _ctx.startTimeStr,
                  onSelectValue: _ctx.selectMeetingStartTime
                }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                _hoisted_6,
                _createVNode(_component_SelectTag, {
                  name: "meeting_start_time",
                  id: "select_meeting_start_time",
                  class: "fl fs20 roundForm noBorder arial",
                  style: {"width":"90px","min-width":"00px","height":"50px"},
                  options: _ctx.timeArray,
                  defaultOption: _ctx.endTimeStr,
                  onSelectValue: _ctx.selectMeetingEndTime
                }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                (_ctx.originDuration != _ctx.duration)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 所要時間が" + _toDisplayString(_ctx.duration) + "分に変更になります ", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}